/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskSubmissionReference } from './taskSubmissionReference';

/**
 * Request for batch task submission training data export
 */
export interface BatchTaskSubmissionTrainingDataRequest {
  /** List of task submission references to export training data for */
  taskSubmissionRefs: TaskSubmissionReference[];
}
